import ProjectServer from "@/models/ProjectServer";

export class Color 
{
    r = 0;
    g = 0;
    b = 0;
}

export class TimelineSyncTagsResponse 
{
    tagid = -1;
    name = '';
    type = '';
    color = new Color;
}

export class SendNodeConnection 
{
    conn = 0;
    text = '';
}

export class TimelineSyncNodesResponse 
{

    nodeid = -1;
    name = '';
    description = '';
    image = '';
    video = '';
    imageCaption = '';
    audio = '';
    color = new Color;

    important = 0;

    start = '';
    end = '';
    dateOptions = 0;

    connections: SendNodeConnection[] = [];
    tags: number[] = [];

    data = '';
}

export class TimelineSyncTimelineTags 
{
    timelineid = -1;
    timelinetags: number[] = [];
}

export class TimelineSyncTimelineNodesResponse 
{
    timelineid = -1;
    nodeid = -1;
}

export class TimelineSyncTimelineEventOrderingResponse 
{
    timelineid = -1;
    name = '';
    ordering: number[] = [];
}

export class ChatSend 
{
    channel = -1;
    sender = '';
    senderId = '';
    timestamp = '';
    text = '';
    messageid = -1;
}

export class TimelineSyncResponsePayload 
{
    tags: TimelineSyncTagsResponse[] = [];
    nodes: TimelineSyncNodesResponse[] = [];
    timelineTags = new TimelineSyncTimelineTags();
    timelineNodes: TimelineSyncTimelineNodesResponse[] = [];
    eventOrderings: TimelineSyncTimelineEventOrderingResponse[] = [];
    chatMessages: ChatSend[] = [];
    accessedTimelines: number[] = [];
}

const SyncTimeline_RPC = "SyncTimeline";
export class TimelineSyncHandlersAsync 
{
    static async SyncTimeline(args: number) 
    {
        return await ProjectServer.instance.AsyncRequests.SendRequest<TimelineSyncResponsePayload, number>(SyncTimeline_RPC, args);
    }
}